module.exports = __webpack_public_path__ + "static/img/1_2.53e9a087.jpg";